import { FC, MouseEventHandler } from 'react';
import './cancel-button.css';

interface Props {
  onCancel: MouseEventHandler<HTMLDivElement>;
  alignToTop?: boolean;
}

export const CancelButton: FC<Props> = ({
  onCancel,
  alignToTop = true,
}) => (
  <div
    className="cancel-btn"
    style={alignToTop ? {
      top: '16px',
    } : {}}
    onClick={onCancel}
  >
      <span
        className="cancel-btn-icon"
      />
  </div>
);